import { render, staticRenderFns } from "./MessagesGrid.vue?vue&type=template&id=521d15d7"
import script from "./MessagesGrid.vue?vue&type=script&lang=js"
export * from "./MessagesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports